import { Instance, types } from "mobx-state-tree";
import { WorkOrderPOProgressBaseModel } from "./work-order-po-progress-base-model";

export const PaperOutputWorkOrderPOProgressModel = types.compose(
  WorkOrderPOProgressBaseModel,
  types.model({}),
);

export const PrintWorkOrderPOProgressModel = types.compose(
  WorkOrderPOProgressBaseModel,
  types.model({
    firstGradeAmount: types.maybeNull(types.number),
    secondGradeAmount: types.maybeNull(types.number),
    rejectedAmount: types.maybeNull(types.number),
  }),
);

export const MatteWorkOrderPOProgressModel = types.compose(
  WorkOrderPOProgressBaseModel,
  types.model({}),
);

export const AcceptanceWorkOrderPOProgressModel = types.compose(
  WorkOrderPOProgressBaseModel,
  types.model({
    firstGradeAmountPcs: types.maybeNull(types.number),
    secondGradeAmountPcs: types.maybeNull(types.number),
    rejectedAmountPcs: types.maybeNull(types.number),
    firstGradeAmountPaper: types.maybeNull(types.number),
    secondGradeAmountPaper: types.maybeNull(types.number),
    rejectedAmountPaper: types.maybeNull(types.number),
  }),
);

export const FoilWorkOrderPOProgressModel = types.compose(
  WorkOrderPOProgressBaseModel,
  types.model({}),
);

export const ShapeWorkOrderPOProgressModel = types.compose(
  WorkOrderPOProgressBaseModel,
  types.model({}),
);

export const PasteWorkOrderPOProgressModel = types.compose(
  WorkOrderPOProgressBaseModel,
  types.model({}),
);

export const CutWorkOrderPOProgressModel = types.compose(
  WorkOrderPOProgressBaseModel,
  types.model({}),
);

export const PackageProgressModel = types.compose(
  WorkOrderPOProgressBaseModel,
  types.model({
    packageNumber: types.maybeNull(types.number),
    packageAmountPerUnit: types.maybeNull(types.number),
    packageWeightPerUnit: types.maybeNull(types.number),
    packageAmount: types.maybeNull(types.number),
    packageWeight: types.maybeNull(types.number),
    packageAmount2: types.maybeNull(types.number),
    packageWeight2: types.maybeNull(types.number),
    packageNote: types.maybeNull(types.string),
  }),
);

export type IPackageProgressModel = Instance<
  typeof PackageProgressModel
> | null;

export type IPrintProgressModel = Instance<
  typeof PrintWorkOrderPOProgressModel
> | null;

export type IAcceptanceProgressModel = Instance<
  typeof AcceptanceWorkOrderPOProgressModel
> | null;
